<aside class="sidebar" [class.collapsed]="isCollapsed()">
  <button class="close-btn" type="button" cdkFocusInitial (click)="onClose()" aria-label="Cerrar menú">Cerrar menú</button>

  <button
    class="collapse-btn"
    type="button"
    (click)="toggleCollapsed()"
    [attr.aria-expanded]="!isCollapsed()"
    [attr.aria-label]="isCollapsed() ? 'Expandir menú' : 'Contraer menú'"
    [attr.title]="isCollapsed() ? 'Expandir menú' : 'Contraer menú'"
  >
    <svg
      class="collapse-icon"
      viewBox="0 0 24 24"
      width="16"
      height="16"
      fill="none"
      stroke="currentColor"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
      aria-hidden="true"
    >
      <polyline points="15 18 9 12 15 6"></polyline>
    </svg>
  </button>

  <div class="brand-logo">
    <span class="brand-logo__full">ARGENTUS MUNDO 3D</span>
    <span class="brand-logo__short">A3D</span>
  </div>

  <nav class="sidebar-menu" aria-label="Administración">
    <div class="sidebar-navigation">
      @for (item of menuItems; track $index) {
        <button
          class="menu-btn"
          [routerLink]="item.route"
          routerLinkActive="active" ariaCurrentWhenActive="page"
          [routerLinkActiveOptions]="{ exact: false }"
          [attr.title]="isCollapsed() ? item.label : null"
          (click)="onClose()"
        >
          <img [src]="item.icon" [alt]="item.label" class="menu-icon" />
          <span class="menu-label">{{ item.label }}</span>
        </button>
      }
    </div>

    <div class="sidebar-footer">
      <button
        class="menu-btn home-btn"
        routerLink=".."
        [attr.title]="isCollapsed() ? 'Página principal' : null"
        (click)="onClose()"
      >
        <img src="assets/icons/back-arrow.svg" alt="Página principal" class="menu-icon" />
        <span class="menu-label">Página principal</span>
      </button>

      <button
        class="menu-btn logout-btn"
        [attr.title]="isCollapsed() ? 'Cerrar sesión' : null"
        (click)="onLogout()"
      >
        <img src="assets/icons/log-out.svg" alt="Cerrar sesión" class="menu-icon" />
        <span class="menu-label">Cerrar sesión</span>
      </button>

      <span class="app-version">v{{ appVersion }}</span>

      <a class="activity-log-link" routerLink="registro-actividad" (click)="onClose()">Registro de actividad</a>
    </div>
  </nav>

</aside>
